/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { OrganizationDtoModel, OrganizationDtoModelType } from "./OrganizationDtoModel"
import { OrganizationDtoModelSelector } from "./OrganizationDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  organization: OrganizationDtoModelType;
}

/**
 * SupportSessionDtoBase
 * auto generated base class for the model SupportSessionDtoModel.
 */
export const SupportSessionDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('SupportSessionDto')
  .props({
    __typename: types.optional(types.literal("SupportSessionDto"), "SupportSessionDto"),
    userUuid: types.union(types.undefined, types.string),
    supportOrganizationUuid: types.union(types.undefined, types.string),
    uuid: types.union(types.undefined, types.string),
    startedOn: types.union(types.undefined, types.string),
    expiresOn: types.union(types.undefined, types.string),
    closedOn: types.union(types.undefined, types.null, types.string),
    organization: types.union(types.undefined, MSTGQLRef(types.late((): any => OrganizationDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class SupportSessionDtoModelSelector extends QueryBuilder {
  get userUuid() { return this.__attr(`userUuid`) }
  get supportOrganizationUuid() { return this.__attr(`supportOrganizationUuid`) }
  get uuid() { return this.__attr(`uuid`) }
  get startedOn() { return this.__attr(`startedOn`) }
  get expiresOn() { return this.__attr(`expiresOn`) }
  get closedOn() { return this.__attr(`closedOn`) }
  organization(builder: string | OrganizationDtoModelSelector | ((selector: OrganizationDtoModelSelector) => OrganizationDtoModelSelector) | undefined) { return this.__child(`organization`, OrganizationDtoModelSelector, builder) }
}
export function selectFromSupportSessionDto() {
  return new SupportSessionDtoModelSelector()
}

export const supportSessionDtoModelPrimitives = selectFromSupportSessionDto().userUuid.supportOrganizationUuid.uuid.startedOn.expiresOn.closedOn
